export class Reseller {
   resellerId: string;
   rut: number;
   dv: string;
   rutCompleto: string;
   razonSocial: string;
   domicilio: string;
   comuna: string;
   ciudad: string;
   fechaCreacion: Date;
   nombreContacto: string;
   telefonoContacto: number;
   emailContacto: string;
   logoFile: string;
   logoCompleteFile: File;
   cantidadEmpresasAsociadas: number;
   usuarioId: string;
   usarLogo: boolean;
}
